import { render, staticRenderFns } from "./attendee.vue?vue&type=template&id=21c3a81f&scoped=true&"
import script from "./attendee.vue?vue&type=script&lang=js&"
export * from "./attendee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3a81f",
  null
  
)

export default component.exports